export const INITIALIZE = '@@redux-autoloader/INITIALIZE';
export const FETCH_DATA_REQUEST = '@@redux-autoloader/FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = '@@redux-autoloader/FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = '@@redux-autoloader/FETCH_DATA_FAILURE';
export const START_REFRESH = '@@redux-autoloader/START_REFRESH';
export const STOP_REFRESH = '@@redux-autoloader/STOP_REFRESH';
export const LOAD = '@@redux-autoloader/LOAD';
export const RESET = '@@redux-autoloader/RESET';
export const SET_CONFIG = '@@redux-autoloader/SET_CONFIG';
